import { ConnectedPosition } from '@angular/cdk/overlay';
import { Directive, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

/** Keep toolbar hints centered below the control, away from the input above it. */
@Directive({ selector: '[composerTooltip]', standalone: true, exportAs: 'composerTooltip' })
export class ComposerTooltipDirective extends MatTooltip {
  @Input() set composerTooltip(message: string) { this.message = message; }

  protected override _addOffset(position: ConnectedPosition): ConnectedPosition {
    // Both candidates stay centered below; CDK keeps the hint inside the
    // viewport without flipping it above the toolbar into the input.
    return { ...position, originX: 'center', overlayX: 'center', originY: 'bottom', overlayY: 'top', offsetX: 0, offsetY: 8 };
  }
}
